import React from "react";
import {
  FaHandsHelping,
  FaLightbulb,
  FaCogs,
  FaCheckCircle,
} from "react-icons/fa";

const supportServices = [
  {
    icon: <FaHandsHelping className="text-4xl text-yellow-500 mb-4" />,
    title: "After-Sales Service",
    points: [
      "Prompt troubleshooting and issue resolution",
      "Warranty support and claim assistance",
      "Regular service reminders (if applicable)",
      "Quick turnaround for replacements or repairs",
    ],
    goal: "To give you peace of mind long after the product is delivered.",
  },
  {
    icon: <FaLightbulb className="text-4xl text-yellow-500 mb-4" />,
    title: "Product Expertise",
    points: [
      "Detailed product walkthroughs",
      "Technical specifications explanation",
      "Usage tips for optimum performance",
      "Industry insights to choose the right solution",
    ],
    goal: "To empower you with the right knowledge to make informed decisions.",
  },
  {
    icon: <FaCogs className="text-4xl text-yellow-500 mb-4" />,
    title: "Customization Assistance",
    points: [
      "Custom product support for unique use-cases",
      "Integration with your existing setup",
      "Options for color, size, performance",
      "Cost-effective expert consultation",
    ],
    goal: "To make the product fit your world, not the other way around.",
  },
  {
    icon: <FaCheckCircle className="text-4xl text-yellow-500 mb-4" />,
    title: "TC Validation",
    points: [
      "Certification & standard verification",
      "Functional & performance testing",
      "Validation report generation",
      "Support for internal/external audits",
    ],
    goal: "To ensure your product is compliant and ready to perform.",
  },
];

const Specialities = () => {
  return (
    <section className="w-full bg-[#fbb613] p-12">
      <div className="text-center mb-12">
        <h2 className="text-3xl sm:text-4xl font-bold text-[#114497] mb-2">
          OUR SUPPORT SERVICES
        </h2>
        <p className="text-gray-600 text-lg font-medium max-w-2xl mx-auto">
          We’re with you beyond the purchase — with knowledge, support, and assurance.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-8 w-full md:max-w-9xl mx-auto">
        {supportServices.map((item, idx) => (
          <div
            key={idx}
            className="flex flex-col items-center bg-[#114497] border border-[#114497] rounded-xl shadow-md p-6 transition duration-300 hover:shadow-xl hover:-translate-y-1"
          >
            {item.icon}
            <h4 className="text-[#fbb613] font-bold text-lg text-center mb-2">
              {item.title}
            </h4>
            <ul className="text-white text-xs list-disc list-inside mb-2 text-left">
              {item.points.map((point, i) => (
                <li key={i} className=" text-wrap md:text-nowrap">{point}</li> // Removed text-nowrap here
              ))}
            </ul>
            <div className="mt-auto text-center">
              <p className="text-[#fbb613] font-semibold underline text-xs italic">
                Goal
              </p>
              <p className="text-white text-xs">{item.goal}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};


export default Specialities;
